var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutDefault",
    [_c("Error403404", { attrs: { errorType: "403" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }